// vue babel plugin doesn't support the pragma replacement
import {mdx} from '@mdx-js/vue'
let h;
/* @jsx mdx */
import Appear from '@/components/Appear'
import CodeSurfer from '@/components/CodeSurfer'

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "div"
function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h2>{`Vue版mdx-deckがあったので使ってみた`}</h2>
    <p>{`taniyuu`}</p>
    <hr></hr>
    <h1>{`自己紹介`}</h1>
    <ul>
      <li parentName="ul">{`taniyuu twitterは`}<a parentName="li" {...{
          "href": "https://twitter.com/zone_tanichan"
        }}>{`@zone_tanichan`}</a><ul parentName="li">
          <li parentName="ul">{`社会人3年目、26歳`}</li>
          <li parentName="ul">{`2019.10〜Vue.jsを仕事で触り始めました。`}</li>
          <li parentName="ul">{`それまでは8割サーバサイド、書いてjQuery`}</li>
        </ul></li>
    </ul>
    <hr></hr>
    <h1>{`TL;DR`}</h1>
    <hr></hr>
    <h1>{`Vue.jsとMarkdownで`}</h1>
    <h1>{`スライドが作れるようになりました🎉`}</h1>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/godkinmo/mdx-vue-deck/"
        }}>{`https://github.com/godkinmo/mdx-vue-deck/`}</a></li>
    </ul>
    <hr></hr>
    <h1>{`サンプルの受け売り`}</h1>
    <hr></hr>
    <h1>{`箇条書きのアニメーション部品`}</h1>
    <Appear mdxType="Appear">
  <li class="text-blue-700">One</li>
  <li>Two</li>
  <li>Three</li>
    </Appear>
    <hr></hr>
    <CodeSurfer lang="javascript" steps={[{
      lines: [3],
      notes: 'Import the Apollo Client'
    }, {
      lines: [4],
      notes: 'Import Vue Apollo for using Apollo with vue'
    }, {
      lines: [7, 8, 9, 10, 11],
      notes: 'Create the provider and give it the URL'
    }, {
      lines: [14],
      notes: 'Tell Vue to use Apollo'
    }, {
      lines: [15, 16, 17, 18, 19],
      notes: 'Mount Vue'
    }]} code={`
import Vue from "vue"
import App from "./App"
import ApolloClient from "apollo-boost"
import VueApollo from "vue-apollo"
\n
const apolloProvider = new VueApollo({
  defaultClient: new ApolloClient({
    uri: "https://api.graphcms.com/simple/v1/awesomeTalksClone"
  })
})
\n
Vue.use(VueApollo)
new Vue({
  el: "#app",
  provide: apolloProvider.provide(),
  render: h => h(App)
})
  `} mdxType="CodeSurfer" />
    <hr></hr>
    <h1>{`プレゼンテーションモードまである！`}</h1>
    <p>{`option + P`}</p>
    <hr></hr>
    <h1>{`紹介はここまで`}</h1>
    <p>{`あとは、時間があれば流しながらそもそもこれって何？を説明する。`}</p>
    <hr></hr>
    <h1>{`MDXとは`}</h1>
    <hr></hr>
    <h1><a href="https://mdxjs.com/" target="_blank">Markdown for the component era</a></h1>
    <ul>
      <li parentName="ul">{`MarkdownでJSXを使えるようにしたもの`}</li>
    </ul>
    <hr></hr>
    <h1>{`🤔`}</h1>
    <hr></hr>
    <h1>{`JSXとは`}</h1>
    <hr></hr>
    <h1>{`5分調べたが…`}</h1>
    <ul>
      <li parentName="ul">{`基本的にはReactでお目にかかるものであると。`}<ul parentName="li">
          <li parentName="ul">{`でもReactで重宝されてるだけで、別にそれ専用のものではないと。`}</li>
        </ul></li>
      <li parentName="ul">{`ネットで調べてもスマートな回答がなかった…`}<ul parentName="li">
          <li parentName="ul">{`twitterでもいいので教えてください。`}</li>
        </ul></li>
    </ul>
    <hr></hr>
    <h1>{`メリット`}</h1>
    <hr></hr>
    <h1>{`やっぱりVue.jsで動いてること！`}</h1>
    <ul>
      <li parentName="ul">{`Markdown記法になれた人からすると、ドキュメント作りと相関がある！`}</li>
      <li parentName="ul">{`それがこんな感じでヌルヌル動いてくれると嬉しい。`}</li>
    </ul>
    <hr></hr>
    <h1>{`デメリット`}</h1>
    <hr></hr>
    <p><img src="https://qiita-image-store.s3.ap-northeast-1.amazonaws.com/0/416137/610e43da-f65b-44df-1b64-9fbea5f2179a.jpeg"  /></p>
    <hr></hr>
    <h1>{`環境構築が大変だった`}</h1>
    <ul>
      <li parentName="ul">{`軽い気持ちで`}<code parentName="li">{`npm install`}</code>{`で行けるだろうと思っていた`}<ul parentName="li">
          <li parentName="ul">{`Macだとまさかの`}<code parentName="li">{`node-gyp`}</code>{`->Xcode必須、windowsは一応`}<code parentName="li">{`wsl`}</code>{`で動かせました。`}</li>
          <li parentName="ul">{`でも発表するために解決してやるぞ！というモチベが上がった。`}</li>
          <li parentName="ul">{`貢献したい気持ちになった。`}</li>
        </ul></li>
    </ul>
    <hr></hr>
    <h1>{`まとめ`}</h1>
    <ul>
      <li parentName="ul">{`みなさんVue.jsでスライド作りましょう！`}</li>
    </ul>
    <h1>{`Future Work`}</h1>
    <ul>
      <li parentName="ul">{`まだまだ未熟なので本家ではできてる機能を作ってみる`}<ul parentName="li">
          <li parentName="ul"><code parentName="li">{`build`}</code>{`時の出力フォルダ指定できるようにする(大事)`}</li>
          <li parentName="ul">{`なぜかmarkdownのリンクが押せない`}</li>
          <li parentName="ul">{`and so on...`}</li>
        </ul></li>
    </ul>
    <hr></hr>
    <h1>{`The END`}</h1>
    <hr></hr>
    <h1>{`コードたち`}</h1>
    <ul>
      <li parentName="ul"><a href="https://github.com/taniyuu/mdx-vue-deck-yumemi" target="_blank">スライド</a></li>
      <li parentName="ul"><a href="https://github.com/taniyuu/mdx-vue-deck" target="_blank">mdx-vue-deck本体をforkして改良したもの</a></li>
      <li parentName="ul"><a href="https://github.com/godkinmo/mdx-vue-deck/" target="_blank">mdx-vue-deck本体(再掲)</a></li>
    </ul>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;

export default {
  name: 'Mdx',
  render(vueCreateElement) {
    h = mdx.bind({vueCreateElement})
    return MDXContent({})
  }
}
   